import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=35d8606a&scoped=true&"
import script from "./AccountData.vue?vue&type=script&lang=js&"
export * from "./AccountData.vue?vue&type=script&lang=js&"
import style0 from "./AccountData.vue?vue&type=style&index=0&id=35d8606a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8606a",
  null
  
)

export default component.exports